module.exports = __webpack_public_path__ + "static/media/default-16-9.5f283b98.svg";